/**
 * Line2D parser: the Node2D transform and modulate, and the polyline properties.
 * Godot defaults: color = white, width = 10, closed = false.
 */
import { parseNode2D } from '../../base/node2d/parser';
import { parseColor } from '../../../utils/colorParser';
import { boolOr, floatOr, intOr, packedOr } from '../../../parser/valueParsers';
import { NO_FLOATS, parsePackedVector2Array } from '../../../resources/shapes/packedArray';
import { LineJointMode } from '../../../godot/scene/line2d.js';
export function parseLine2D(heading, properties) {
    const base = parseNode2D(heading, properties);
    const points = packedOr(properties.points, parsePackedVector2Array, NO_FLOATS, `Line2D "${base.name}".points`);
    return {
        ...base,
        points,
        width: floatOr(properties.width, 10, base.name || 'Line2D'),
        defaultColor: properties.default_color
            ? parseColor(properties.default_color)
            : { r: 1, g: 1, b: 1, a: 1 },
        closed: boolOr(properties.closed, false, base.name || 'Line2D'),
        // class_line2d.html: sharp_limit 2.0, round_precision 8.
        jointMode: intOr(properties.joint_mode, LineJointMode.SHARP),
        sharpLimit: floatOr(properties.sharp_limit, 2, base.name || 'Line2D'),
        roundPrecision: intOr(properties.round_precision, 8),
    };
}
//# sourceMappingURL=parser.js.map